/*دام و طیور*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      data-name="Farm Field"
      xmlns="http://www.w3.org/2000/svg"
      width={90.569}
      height={90.632}
      viewBox="0 0 90.569 90.632"
      {...props}
    >
      <g transform="translate(0 7.076)">
        <path
          data-name="Path 7713"
          d="M88.741 56.605c-19.5.1-26.475 7.073-26.475 7.073s-8.491 7.076-5.661 18.4a1.415 1.415 0 001.415 1.415h32.548V56.605z"
          fill="#49ad4d"
        />
        <path
          data-name="Path 7714"
          d="M12.736 8.491a8.491 8.491 0 018.491 8.491v43.869H4.245V16.982a8.491 8.491 0 018.491-8.491z"
          fill="#e2dbd5"
        />
        <path
          data-name="Path 7715"
          d="M21.227 29.596a28.97 28.97 0 01-16.982 9.603v21.652h16.982z"
          fill="#d4ccc7"
        />
        <circle
          data-name="Ellipse 368"
          cx={2.83}
          cy={2.83}
          r={2.83}
          transform="translate(5.661 22.642)"
          fill="#efebe8"
        />
        <circle
          data-name="Ellipse 369"
          cx={1.415}
          cy={1.415}
          r={1.415}
          transform="translate(12.736 26.888)"
          fill="#efebe8"
        />
        <path
          data-name="Path 7716"
          d="M89.154 82.077S72.4 56.946 2.83 56.605H0v26.888h90.569z"
          fill="#81c784"
        />
        <path
          data-name="Path 7717"
          d="M42.661 83.493h47.907l-1.415-1.415s-6.98-10.466-30.627-17.98a38.33 38.33 0 01-15.865 19.395z"
          fill="#66bb6a"
        />
        <rect
          data-name="Rectangle 737"
          width={11.321}
          height={16.982}
          rx={5.661}
          transform="translate(77.832 32.548)"
          fill="#49ad4d"
        />
        <rect
          data-name="Rectangle 738"
          width={11.321}
          height={16.982}
          rx={5.661}
          transform="translate(69.342 35.378)"
          fill="#81c784"
        />
        <circle
          data-name="Ellipse 370"
          cx={9.906}
          cy={9.906}
          r={9.906}
          transform="translate(60.851)"
          fill="#ea6049"
        />
        <path
          data-name="Path 7718"
          d="M80.663 43.379a12.7 12.7 0 01-9.906 4.736c-.423 0-.84-.024-1.252-.065a5.661 5.661 0 0011.158-1.35z"
          fill="#66bb6a"
        />
        <circle
          data-name="Ellipse 371"
          cx={2.123}
          cy={2.123}
          r={2.123}
          transform="translate(70.757 36.794)"
          fill="#c8e6c9"
        />
        <circle
          data-name="Ellipse 372"
          cx={1.415}
          cy={1.415}
          r={1.415}
          transform="translate(76.417 39.624)"
          fill="#c8e6c9"
        />
        <path
          data-name="Path 7719"
          d="M77.814 2.956a13.71 13.71 0 01-14 14.017 9.906 9.906 0 1014-14.018z"
          fill="#de513e"
        />
        <circle
          data-name="Ellipse 373"
          cx={2.83}
          cy={2.83}
          r={2.83}
          transform="translate(63.681 2.83)"
          fill="#f27c6d"
        />
        <circle
          data-name="Ellipse 374"
          cx={1.415}
          cy={1.415}
          r={1.415}
          transform="translate(70.757 8.491)"
          fill="#f27c6d"
        />
        <path
          data-name="Path 7720"
          d="M16.982 41.039h12.736v21.227H16.982z"
          fill="#de513e"
        />
        <path
          data-name="Path 7721"
          d="M16.982 57.446v4.82h12.736V49.623a17.445 17.445 0 01-12.736 7.823z"
          fill="#cf3f30"
        />
        <path
          data-name="Path 7722"
          d="M43.87 29.718H31.133l-9.906 5.661-4.245 5.66H43.87z"
          fill="#a1887f"
        />
        <path
          data-name="Path 7723"
          d="M34.518 29.718a17.221 17.221 0 01-15.4 8.473l-2.136 2.848H43.87V29.718z"
          fill="#9c7b70"
        />
        <path
          data-name="Path 7724"
          d="M29.718 60.721v1.545h28.3V41.039l-1.446-1.928a31.155 31.155 0 01-26.854 21.61z"
          fill="#de513e"
        />
        <path
          data-name="Path 7725"
          d="M58.018 62.266h-28.3V41.039l4.245-5.661 9.906-5.66 9.906 5.661 4.245 5.661z"
          fill="#ea6049"
        />
        <path
          data-name="Path 7726"
          d="M35.378 45.284H52.36v16.982H35.378z"
          fill="#fff"
        />
        <circle
          data-name="Ellipse 375"
          cx={1.415}
          cy={1.415}
          r={1.415}
          transform="translate(28.303 31.133)"
          fill="#bcaaa4"
        />
        <circle
          data-name="Ellipse 376"
          cx={1.415}
          cy={1.415}
          r={1.415}
          transform="translate(22.642 33.963)"
          fill="#bcaaa4"
        />
        <g
          data-name="Group 370"
          transform="translate(41.039 31.133)"
          fill="#f27c6d"
        >
          <circle data-name="Ellipse 377" cx={2.123} cy={2.123} r={2.123} />
          <circle
            data-name="Ellipse 378"
            cx={1.415}
            cy={1.415}
            r={1.415}
            transform="translate(5.661 2.83)"
          />
        </g>
      </g>
      <path
        data-name="Path 7727"
        d="M90.331 88.369c-.253-.38-6.429-9.388-26.155-16.746a1.415 1.415 0 00-.989 2.652c18.758 7 24.734 15.582 24.79 15.664a1.415 1.415 0 102.355-1.57z"
      />
      <path
        data-name="Path 7728"
        d="M1.415 76.417c30.213 0 45.794 3.259 46.788 3.259a1.416 1.416 0 00.224-2.813 299.051 299.051 0 00-47.012-3.276 1.415 1.415 0 100 2.83z"
      />
      <path
        data-name="Path 7729"
        d="M82.983 88.067c-.242-.2-6.13-4.991-23.352-9.012a1.415 1.415 0 10-.643 2.756c22.619 5.281 22.216 10.6 24.177 8.249a1.415 1.415 0 00-.182-1.993z"
      />
      <path
        data-name="Path 7730"
        d="M1.415 83.493c9.186 0 13.373.184 14.156.184a1.416 1.416 0 00.037-2.83 533.631 533.631 0 00-14.193-.184 1.415 1.415 0 100 2.83z"
      />
      <path
        data-name="Path 7731"
        d="M72.68 87.832c-.51-.2-12.866-4.824-45.754-6.544a1.415 1.415 0 10-.148 2.826c43.514 2.276 45.5 8.714 46.715 5.546a1.415 1.415 0 00-.813-1.828z"
      />
      <path
        data-name="Path 7732"
        d="M41.039 87.738H1.415a1.415 1.415 0 100 2.83h39.624a1.415 1.415 0 100-2.83z"
      />
      <path
        data-name="Path 7733"
        d="M89.153 62.266q-2.225 0-4.245.112v-2.939a1.415 1.415 0 00-2.83 0v3.151a59.441 59.441 0 00-5.661.8v-2.681a7.087 7.087 0 005.661-6.934v-5.661a7.076 7.076 0 10-14.151 0v5.661a7.087 7.087 0 005.661 6.934v3.3a38.6 38.6 0 00-7.7 2.747 1.415 1.415 0 101.251 2.539c3.884-1.914 10.856-4.195 22.017-4.195a1.415 1.415 0 000-2.83zM74.998 49.53a1.415 1.415 0 00-1.415 1.415v6.832a4.252 4.252 0 01-2.83-4v-5.661a4.245 4.245 0 018.491 0v5.661a4.252 4.252 0 01-2.83 4v-6.832a1.415 1.415 0 00-1.416-1.415z"
      />
      <path
        data-name="Path 7734"
        d="M89.153 69.342a91.352 91.352 0 00-14.264.989 1.415 1.415 0 00.449 2.795 88.519 88.519 0 0113.816-.954 1.415 1.415 0 100-2.83z"
      />
      <path
        data-name="Path 7735"
        d="M89.157 75.002c-1.905 0-3.821.071-5.7.209a1.415 1.415 0 00.209 2.823 74.44 74.44 0 015.487-.2 1.415 1.415 0 100-2.83z"
      />
      <path
        data-name="Path 7736"
        d="M15.723 47.469c-.241.469-.15-.991-.157 21.873a1.415 1.415 0 001.415 1.415h41.037a1.415 1.415 0 001.415-1.415c-.1-21.991.25-21.365-.283-22.076-4.506-5.942-4.227-5.784-4.675-6.04-10.571-6.04-10.071-5.847-10.608-5.847-13.275.065-12.826-.163-13.438.186l-9.906 5.661c-.352.202-4.682 6.019-4.8 6.243zm12.579 20.458h-9.906v-18.4h9.906zm13.565-7.076l-5.074 5.074V55.776zm-3.073-7.076h10.149l-5.074 5.074zm0 14.151l5.074-5.074 5.074 5.074zm12.15-2l-5.075-5.074 5.075-5.075zm1.874-22.388l3.787 5.049v19.34h-2.83c0-16.677.238-16.09-.564-16.7a1.424 1.424 0 00-.851-.286c-18.31 0-17.59-.221-18.159.63-.439.656-.15.282-.238 16.352h-2.83v-19.34l3.787-5.049 8.949-5.114zm-21.31-5.329h7.032c-5.51 3.193-5.4 2.984-5.709 3.4l-3.821 5.095h-9.2l2.372-3.162z"
      />
      <circle
        data-name="Ellipse 379"
        cx={1.415}
        cy={1.415}
        r={1.415}
        transform="translate(39.624 45.284)"
      />
      <circle
        data-name="Ellipse 380"
        cx={1.415}
        cy={1.415}
        r={1.415}
        transform="translate(52.36 77.832)"
      />
      <circle
        data-name="Ellipse 381"
        cx={1.415}
        cy={1.415}
        r={1.415}
        transform="translate(19.812 80.663)"
      />
      <circle
        data-name="Ellipse 382"
        cx={1.415}
        cy={1.415}
        r={1.415}
        transform="translate(15.566 15.566)"
      />
      <circle
        data-name="Ellipse 383"
        cx={1.415}
        cy={1.415}
        r={1.415}
        transform="translate(45.284 45.284)"
      />
      <path
        data-name="Path 7737"
        d="M82.336 38.304a1.415 1.415 0 00.46 2.793 4.244 4.244 0 014.943 4.188v5.66a4.238 4.238 0 01-2.282 3.766 1.415 1.415 0 101.311 2.508 7.058 7.058 0 003.8-6.274v-5.66a7.077 7.077 0 00-8.233-6.981z"
      />
      <path
        data-name="Path 7738"
        d="M70.757 28.303a11.321 11.321 0 10-11.321-11.321 11.321 11.321 0 0011.321 11.321zm0-19.812a8.491 8.491 0 11-8.491 8.491 8.491 8.491 0 018.491-8.491z"
      />
      <circle
        data-name="Ellipse 384"
        cx={1.415}
        cy={1.415}
        r={1.415}
        transform="translate(69.342)"
      />
      <circle
        data-name="Ellipse 385"
        cx={1.415}
        cy={1.415}
        r={1.415}
        transform="translate(56.605 5.661)"
      />
      <circle
        data-name="Ellipse 386"
        cx={1.415}
        cy={1.415}
        r={1.415}
        transform="translate(82.078 28.303)"
      />
      <circle
        data-name="Ellipse 387"
        cx={1.415}
        cy={1.415}
        r={1.415}
        transform="translate(80.663 4.245)"
      />
      <circle
        data-name="Ellipse 388"
        cx={1.415}
        cy={1.415}
        r={1.415}
        transform="translate(58.021 26.888)"
      />
      <circle
        data-name="Ellipse 389"
        cx={1.415}
        cy={1.415}
        r={1.415}
        transform="translate(84.908 15.566)"
      />
      <circle
        data-name="Ellipse 390"
        cx={1.415}
        cy={1.415}
        r={1.415}
        transform="translate(53.775 15.566)"
      />
      <circle
        data-name="Ellipse 391"
        cx={1.415}
        cy={1.415}
        r={1.415}
        transform="translate(69.342 31.133)"
      />
      <path
        data-name="Path 7739"
        d="M1.415 62.266a1.415 1.415 0 000 2.83h9.906a1.415 1.415 0 000-2.83h-5.66V26.887h14.151v8.491a1.415 1.415 0 102.83 0v-8.491h1.415a1.415 1.415 0 000-2.83h-1.415a9.872 9.872 0 00-.57-3.319 1.415 1.415 0 10-2.667.948 7.052 7.052 0 01.407 2.37H5.661a7.113 7.113 0 016.024-7 1.415 1.415 0 00-.417-2.8 9.96 9.96 0 00-8.438 9.8H1.415a1.415 1.415 0 000 2.83H2.83v35.378z"
      />
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
